'use strict';

var processInclude = require('./util');

$(function () {
    processInclude(require('./article/article'));
    processInclude(require('./article/articleSearch'));
});
